// extracted by mini-css-extract-plugin
export default {"active":"Lecture_active__3P9mU"};